"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dumblabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const invisible_1 = __importDefault(require("../invisible/invisible"));
const status_1 = require("../constants/status");
const dumblabel_style_1 = __importDefault(require("./dumblabel.style"));
class Dumblabel extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, hideLabel, text, forId, children, inputHasFocus, inputHasValue, status, maxWidth, required } = this.props;
            const rootProps = {
                className: classes.root,
                'data-input-has-focus': inputHasFocus,
                'data-input-has-value': inputHasValue,
                'data-input-is-required': required,
                'data-input-is-invalid': status === status_1.STATUS_INVALID,
                'data-input-is-caution': status === status_1.STATUS_CAUTION,
                'data-input-is-valid': status === status_1.STATUS_VALID,
                'data-is-max-width': maxWidth
            };
            return (jsx_runtime_1.jsxs("label", Object.assign({}, rootProps, { htmlFor: forId }, { children: [jsx_runtime_1.jsx(invisible_1.default, Object.assign({ visible: !hideLabel }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.label }, { children: jsx_runtime_1.jsx("span", { children: text }, void 0) }), void 0) }), void 0), children] }), void 0));
        };
    }
}
exports.Dumblabel = Dumblabel;
Dumblabel.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    text: prop_types_1.default.string.isRequired,
    forId: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.node.isRequired,
    inputHasFocus: prop_types_1.default.bool.isRequired,
    inputHasValue: prop_types_1.default.bool.isRequired,
    status: prop_types_1.default.oneOf([status_1.STATUS_INVALID, status_1.STATUS_CAUTION, status_1.STATUS_VALID]),
    maxWidth: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    hideLabel: prop_types_1.default.bool
};
Dumblabel.defaultProps = {
    status: null,
    maxWidth: false,
    required: false,
    hideLabel: false
};
exports.default = react_jss_1.default(dumblabel_style_1.default)(Dumblabel);
//# sourceMappingURL=index.js.map